import * as React from 'react';
import '../../styles/Header.css';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import { ProspectBasePath } from '../pages/prospect/ProspectRouteValues';
import { prospectPages, prospectPath } from '../pages/prospect/ProspectRouter';

const logoColor = require('../../images/logo-color.png');
const hamburgerIcon = require('../../images/hamburger-menu.svg');
const closeIcon = require('../../images/close-menu.svg');

interface HeaderProps extends RouteComponentProps<{}> {
    faqsSlug?: string;
}

const ProspectHeader = (props: HeaderProps) => {
    return (
        <header className="header">
            <nav className="container d-flex align-items-center">
                {props.location.pathname === ProspectBasePath ? (
                    <img
                        src={closeIcon}
                        className="menu-icon"
                        onClick={() => props.history.goBack()}
                    />
                ) : (
                    <Link to={ProspectBasePath}>
                        <img src={hamburgerIcon} className="menu-icon" />
                    </Link>
                )}
                <Link to={prospectPath(prospectPages.welcome)} className="mr-auto">
                    <img src={logoColor} className="tour24-logo" />
                </Link>
                {props.faqsSlug && (
                    <Link
                        to={`${prospectPath(prospectPages.propertyFaq)}/${props.faqsSlug}`}
                        className="tour-workflow-property-faqs"
                    >
                        Property FAQs
                    </Link>
                )}
            </nav>
        </header>
    );
};

export default withRouter(ProspectHeader);



// WEBPACK FOOTER //
// ./src/components/common/ProspectHeader.tsx